import React, { FunctionComponent } from 'react';
import className from '@wavevision/class-name';

import Svg from '@flowgate/core/ui/Components/Svg/assets/scripts';

import close from '../../../../../../assets/images/icons/close.svg';

import {
  ModalBodyProps,
  ModalContainerProps,
  ModalFooterProps,
  ModalHeaderProps,
} from './types';

const containerClassName = className<ModalContainerProps>(
  'modal-dialog',
  () => ({ narrow: true, wide: true }),
);
const bodyClassName = className<ModalBodyProps>('modal-body', () => ({
  noPadding: true,
  noScroll: true,
}));

export const Container: FunctionComponent<ModalContainerProps> = props => {
  const className = containerClassName({ props });
  return (
    <div className={className.block()} role="document">
      <div className="modal-content">{props.children}</div>
    </div>
  );
};

export const Header: FunctionComponent<ModalHeaderProps> = props => (
  <div className="modal-header">
    {props.title && <h2 className="modal-title">{props.title}</h2>}
    <span
      className="close modal-close"
      onClick={props.onClose}
      role="button"
      aria-label="Close"
    >
      <Svg symbol={close} />
    </span>
  </div>
);

export const Body: FunctionComponent<ModalBodyProps> = props => {
  const className = bodyClassName({ props });
  return <div className={className.block()}>{props.children}</div>;
};

export const Footer: FunctionComponent<ModalFooterProps> = props => (
  <div className="modal-footer">
    <div className="modal-footer-container">{props.children}</div>
  </div>
);
